<template>
  <AbsPopup id="AdminPoint" :title="type === 2 ? '수익금 관리' : '포인트 관리'" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <div>
          <div>
            <span v-if="type === 0"><b>포인트 지급</b></span>
            <Uselectbox v-else-if="type === 1" class="option" :width="130" description="선택" :options="pointlist" @selected="pointselect" v-model="pointindex" />
            <span v-else><b>수익금 차감</b></span>
          </div>
          <div>
            <Uselectbox class="option" :width="100" description="선택" :options="arrestlist" @selected="arrestselect" v-model="arrestindex" />
          </div>
        </div>
        <div class="inputPoint">
          <icon size="xsmall" uicon="146" />
          <UInput type="text" placeholder="지급할 포인트를 입력 하세요" align="right" v-model="point"/>
        </div>
        <div>
          <span>사유</span>
        </div>
        <div>
          <UInput type="text" line="box" placeholder="사유를입력해주세요" align="left" v-model="message"/>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'

export default {
  props: {
    option: {
      type: Object
    }
  },
  mounted () {
    this.image = this.option.param.image
    this.message = this.option.param.message
    this.$emit('loading', false)
  },
  data: () => {
    return {
      arrestindex: -1,
      pointindex: -1,
      point: '',
      message: ''
    }
  },
  name: 'AdminPoint',
  computed: {
    type () {
      return this.option.param.type
    },
    pointlist () {
      return [
        {text: '포인트 지급'},
        {text: '포인트 차감'}
      ]
    },
    arrestlist () {
      switch (this.type) {
        case 0 :
          return [
            {text: '선물'},
            {text: '환불'}
          ]
        case 1 :
          switch (this.pointindex) {
            case 0 :
              return [
                {text: '선물'},
                {text: '환불'}
              ]
            case 1 :
              return [
                {text: '기타'}
              ]
            default :
              return [
                {text: '선물'},
                {text: '환불'}
              ]
          }
        case 2 :
          return [
            {text: '환불'}
          ]
      }
    }
  },
  methods: {
    arrestselect (e) {
      console.log(e)
    },
    pointselect (e) {
      console.log(e)
    },
    submit () {
      var users = []
      this.option.param.user.forEach(item => {
        users.push(item.UserID)
      })
      var t = 0
      var p = 0
      switch (this.type) {
        case 0 :
          t = this.arrestindex + 6
          p = Number(this.point)
          break
        case 1 :
          switch (this.pointindex) {
            case 0 :
              t = this.arrestindex + 6
              p = Number(this.point)
              break
            case 1 :
              t = 8
              p = Number(this.point) * -1
              break
          }
          break
        case 2 :
          t = 9
          p = Number(this.point) * -1
          break
      }
      this.$http.post('/api/admin/user/addPoint', {type: t, users: users, point: p, message: this.message}).then((e) => {
        console.log(e)
        this.$emit('submit')
      })
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
.popup-body {
  width: 450px;
  padding: 20px;
}
.popup-body > div {
  line-height: 24px;
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  padding-bottom: 5px;
  margin-bottom: 5px;
}
.popup-body > div:first-child > div:first-child {
  margin-right: auto;
}
.popup-body > div .input {
  width: 100%;
  height: 24px;
}
.inputPoint {
  border-bottom: 1px solid var(--line-base);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/admin/AdminPoint.vue